/*
 * SmartReserve stapelcomponent (okt 2026). Opvolger van de Halo-hero, nu voor alle vier.
 * - Lagen uit echte fabrieksbeelden (window.SR_STAPEL, snippets/sr-stapel-config.liquid).
 * - Stappen uit de metafields (stap_kwh, max_kwh_per_unit) en het aantal torens uit de thema-instellingen.
 * - Prijs alleen als de stand een variant is (of bij de HYXI een aantal gelijke torens): anders "Prijs op aanvraag"
 *   met de knop "Ik wil maatwerkadvies". Nooit een prijs optellen of verzinnen.
 * - prefers-reduced-motion: direct de eindstand. Een live region leest de nieuwe stand voor.
 * Gebruik: SRStapel.mount(el, { mode: 'hero'|'config'|'compact', brand: 'huisvriend', fixed: false, form: formEl })
 *          SRStapel.mini(el, key, n, m)   (kleine, stilstaande stapel in een kaart)
 */
(function (root) {
  'use strict';
  var reduced = root.matchMedia && root.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var GAP = 0.12; // ruimte tussen torens, als deel van de breedte van één toren

  function V() { return root.SRV; }
  function cfg(key) { return (root.SR_STAPEL || {})[key] || null; }
  function bat(key) { return V() ? V().byKey(key) : null; }
  function canCombine(b) { var a = (root.SR_VIER && root.SR_VIER.aannames) || {}; return b && b.key === (a.combineKey || 'huisvriend'); }

  /* Welke lagen horen bij m modules in één toren */
  function layersFor(c, m) {
    if (!c) return [];
    if (m <= 1 && c.solo) return [c.solo];
    if (c.slots) return c.layers.slice(0, Math.max(1, m));
    if (c.layers.length > 1 && c.layers[1].repeat) {
      var out = [c.layers[0]];
      for (var i = 1; i < m; i++) out.push(c.layers[1]);
      return out;
    }
    if (c.counter) {
      // Geen schoon fabrieksbeeld van de uitbreidingsmodule: een gelabelde omtrek (schema), geen nagemaakte foto
      var o = [c.layers[0]];
      for (var j = 1; j < m; j++) o.push({ schema: c.counter, h: c.counterH || 360, step: c.counterH || 360, inset: c.counterInset || 0.08 });
      if (o.length > 1) { o[0] = { src: c.layers[0].src, srcS: c.layers[0].srcS, h: c.layers[0].h, step: c.layers[0].h - (c.counterOverlap || 40) }; }
      return o;
    }
    return [c.layers[0]];
  }
  function natH(ls) { var t = 0; for (var i = 0; i < ls.length - 1; i++) t += ls[i].step; return t + (ls.length ? ls[ls.length - 1].h : 0); }

  /* Prijs en gegevens van een stand (n torens of units, m modules per toren) */
  function stand(b, n, m) {
    var c = cfg(b.key) || {}, vs = b.variants || [];
    var v = vs.filter(function (x) { return x.units === n && x.modules === n * m; })[0], qty = 1;
    if (!v && canCombine(b)) { v = vs.filter(function (x) { return x.units === 1 && x.modules === m; })[0]; qty = v ? n : 1; }
    if (v && v.available === false) v = null;
    var kwh = v ? v.kwh * qty : n * m * b.stapKwh;
    var groepW = v ? (v.w || b.groepW) * qty : (b.groepW || 0) * n;
    var mods = m - (c.topCounts === false ? 0 : 1);
    var parts;
    if (n > 1 && m === 1 && c.basisWord) parts = n + ' ' + c.basisWord;
    else {
      var inner = c.top ? (c.top + (c.module && mods > 0 ? ' met ' + mods + ' ' + c.module : '')) : '';
      if (c.slots) inner = m + ' modules';
      parts = (n > 1 ? n + ' ' + (c.unitPlural || 'units') : '1 ' + (c.unit || 'unit')) + (inner ? (n > 1 ? ', elk ' : ', ') + inner : '');
    }
    var title = (n > 1 && canCombine(b) ? n + ' × ' + V().kwh(kwh / n) : V().kwh(kwh));
    return { n: n, m: m, variant: v || null, qty: qty, price: v ? v.price * qty : null, kwh: kwh, groepW: groepW, stopW: b.stopW || 800,
             title: title, parts: parts, onRequest: !v, adviesprijs: v && b.toonAdvies && v.adviesprijs > v.price ? v.adviesprijs * qty : 0 };
  }
  function limits(b) {
    var c = cfg(b.key) || {};
    return { minM: c.minModules || 1, maxM: c.maxModules || 1, maxN: Math.max(c.towersMax || 1, c.towersMaxBasis || 0), towersMax: c.towersMax || 1 };
  }
  /* startstand: klein beginnen (instelling per merk), binnen de grenzen */
  function startM(b) { var c = cfg(b.key) || {}, L = limits(b); return Math.max(L.minM, Math.min(L.maxM, c.startModules || L.minM)); }

  function clampStand(b, n, m) {
    var L = limits(b);
    n = Math.max(1, Math.min(L.maxN, n));
    m = Math.max(L.minM, Math.min(L.maxM, m));
    if (n > L.towersMax) m = 1 < L.minM ? L.minM : 1;
    return { n: n, m: m };
  }

  /* ---------- De stapel zelf (wereld met torens, camera zoomt mee) ---------- */
  function Scene(stage) {
    this.stage = stage;
    this.world = document.createElement('div');
    this.world.className = 'vb-st__world';
    stage.appendChild(this.world);
    this.towers = [];
    this.key = null;
  }
  Scene.prototype.render = function (key, n, m, instant) {
    var c = cfg(key); if (!c) return;
    var small = this.stage.classList.contains('vb-st__mini');
    if (key !== this.key) { this.world.innerHTML = ''; this.towers = []; this.key = key; instant = true; }
    // m mag per toren verschillen (bijvoorbeeld Halo 9 + 2 × Halo 6): torens staan dan op dezelfde vloer
    var ms = []; for (var q = 0; q < n; q++) ms.push(Array.isArray(m) ? (m[q] || m[m.length - 1]) : m);
    var LS = ms.map(function (mm) { return layersFor(c, mm); });
    var H = Math.max.apply(null, LS.map(natH)), W = c.w, gap = W * GAP;
    var worldW = n * W + (n - 1) * gap;
    this.world.style.width = worldW + 'px';
    this.world.style.height = H + 'px';
    while (this.towers.length > n) { var t = this.towers.pop(); t.el.parentNode.removeChild(t.el); }
    while (this.towers.length < n) {
      var el = document.createElement('div'); el.className = 'vb-st__tower';
      el.style.width = W + 'px';
      this.world.appendChild(el);
      this.towers.push({ el: el, imgs: [] });
      if (!instant) el.classList.add('is-new');
    }
    var self = this;
    if (instant) { this.world.classList.add('is-instant'); }
    this.towers.forEach(function (t, i) {
      var ls = LS[i], th = natH(ls);
      t.el.style.left = (i * (W + gap)) + 'px';
      t.el.style.height = th + 'px';
      var top = 0;
      ls.forEach(function (l, j) {
        var im = t.imgs[j];
        var fresh = !im;
        var lsrc = small && l.srcS ? l.srcS : l.src;
        var want = l.schema ? 'schema:' + l.schema : lsrc;
        if (im && im.getAttribute('data-src') !== want) { im.parentNode.removeChild(im); im = null; t.imgs[j] = null; fresh = true; }
        if (!im) {
          if (l.schema) {
            im = document.createElement('div'); im.className = 'vb-st__schema';
            im.innerHTML = '<span>' + l.schema + '</span>';
            im.style.left = (l.inset * 100) + '%'; im.style.right = (l.inset * 100) + '%'; im.style.width = 'auto'; im.style.height = (l.h - 14) + 'px';
          } else {
            im = document.createElement('img'); im.alt = ''; im.decoding = 'async'; im.draggable = false; im.src = lsrc; im.width = W; im.height = l.h;
          }
          im.setAttribute('data-src', want);
          t.el.appendChild(im); t.imgs[j] = im;
        }
        im.style.top = top + 'px';
        im.style.zIndex = String(20 - j);
        if (fresh && !instant && !reduced && j > 0) {
          im.style.transition = 'none';
          im.style.transform = 'translateY(-' + ls[j - 1].step + 'px)';
          im.style.opacity = '0';
          void im.offsetHeight;
          im.style.transition = '';
          im.style.transform = 'translateY(0)';
          im.style.opacity = '1';
        } else { im.style.transform = 'translateY(0)'; im.style.opacity = '1'; }
        top += l.step;
      });
      while (t.imgs.length > ls.length) { var x = t.imgs.pop(); x.parentNode.removeChild(x); }
      if (t.el.classList.contains('is-new')) { requestAnimationFrame(function () { t.el.classList.remove('is-new'); }); }
    });
    this.nat = { w: worldW, h: H };
    this.camera(instant);
    if (instant) { var wd = this.world; void wd.offsetHeight; requestAnimationFrame(function () { wd.classList.remove('is-instant'); }); }
  };
  Scene.prototype.camera = function (instant) {
    if (!this.nat) return;
    var sw = this.stage.clientWidth, sh = this.stage.clientHeight;
    if (!sw || !sh) return;
    if (this.adapt) {
      // hoogte van het podium volgt de verhouding van de opstelling: geen lege lucht boven brede opstellingen
      var want = Math.round(Math.min(this.adapt, Math.max(this.adapt * 0.55, (sw * 0.9) * this.nat.h / this.nat.w / 0.86 + 40)));
      if (Math.abs(want - sh) > 2) { this.stage.style.height = want + 'px'; sh = want; }
    }
    var isMini = this.stage.classList.contains('vb-st__mini');
    var s = isMini ? Math.min((sh - 4) / this.nat.h, (sw * 0.86) / this.nat.w) : Math.min((sh * 0.86) / this.nat.h, (sw * 0.9) / this.nat.w);
    // brede, lage opstellingen niet tegen de vloer plakken met een lege lucht erboven
    var free = sh - this.nat.h * s;
    this.world.style.bottom = (isMini ? (this.stage.classList.contains('is-floor') ? 2 : Math.max(2, free / 2)) : Math.max(26, free * 0.32)) + 'px';
    if (instant || reduced) { this.world.style.transition = 'none'; }
    this.world.style.transform = 'translateX(-50%) scale(' + s.toFixed(4) + ')';
    if (instant || reduced) { void this.world.offsetHeight; this.world.style.transition = ''; }
  };

  /* ---------- Kleine, stilstaande stapel (kaarten, keuzeknoppen) ---------- */
  function mini(el, key, n, m) {
    el.classList.add('vb-st__mini');
    el.innerHTML = '';
    var sc = new Scene(el);
    sc.render(key, n, m, true);
    if ('ResizeObserver' in root) { new ResizeObserver(function () { sc.camera(true); }).observe(el); }
    else requestAnimationFrame(function () { sc.camera(true); });
    return sc;
  }

  /* ---------- Interactieve component ---------- */
  function mount(el, opts) {
    opts = opts || {};
    var list = (V() && V().batteries()) || [];
    list = list.filter(function (b) { return cfg(b.key) && b.stapKwh > 0; });
    if (!list.length) { el.hidden = true; return null; }
    var mode = opts.mode || 'hero';
    var state = { key: opts.brand && list.some(function (b) { return b.key === opts.brand; }) ? opts.brand : list[0].key, n: 1, m: 0,
                  aansl: (V().store.aansluiting() || 'stopcontact') };
    var b = bat(state.key);
    var L = limits(b);
    var start = opts.start || {};
    state.n = start.n || 1; state.m = start.m || (mode === 'hero' ? startM(b) : L.minM);
    var cs = clampStand(b, state.n, state.m); state.n = cs.n; state.m = cs.m;

    el.classList.add('vb-st', 'vb-st--' + mode);
    var html = '';
    if (!opts.fixed) {
      html += '<div class="vb-st__brands" role="radiogroup" aria-label="Kies een merk">' + list.map(function (x) {
        var c = cfg(x.key);
        return '<button type="button" role="radio" class="vb-st__brand" data-st-brand="' + x.key + '" aria-checked="false" aria-label="' + V().esc(x.brand + ', ' + x.klasse) + '">' +
          '<img src="' + V().esc(c.logo) + '" alt="" loading="lazy" decoding="async"></button>';
      }).join('') + '</div>';
    }
    html += '<div class="vb-st__stage" data-st-stage><div class="vb-st__floor" aria-hidden="true"></div></div>';
    if (mode === 'config') {
      html += '<div class="vb-st__pick"><p class="vb-st__label" data-st-nlabel>Aantal</p><div class="vb-st__opts" data-st-nopts></div>' +
              '<p class="vb-st__label" data-st-mlabel>Capaciteit</p><div class="vb-st__opts vb-st__opts--m" data-st-mopts></div></div>';
    } else {
      html += '<div class="vb-st__ctl">' +
        '<div class="vb-seg vb-st__nseg" data-st-nseg role="group" aria-label="Aantal torens of units"></div>' +
        '<div class="vb-st__plusmin" role="group" aria-label="Capaciteit per toren">' +
          '<button type="button" class="vb-st__pm" data-st-minus aria-label="Eén module minder">−</button>' +
          '<span class="vb-st__pmval" data-st-pmval></span>' +
          '<button type="button" class="vb-st__pm" data-st-plus aria-label="Eén module meer">+</button>' +
        '</div></div>';
    }
    html += '<div class="vb-st__readout" data-st-readout></div>' +
      '<p class="vb-sr" aria-live="polite" data-st-live></p>';
    el.innerHTML = html;
    var stage = el.querySelector('[data-st-stage]');
    var scene = new Scene(stage);
    if (mode !== 'hero') scene.adapt = parseInt(getComputedStyle(el).getPropertyValue('--st-h'), 10) || 440;

    function readout(s) {
      var x = bat(state.key), wNow = s.groepW || s.stopW;
      var out = '<p class="vb-st__ro-name"><span>' + V().esc(x.klasse) + '</span> ' + V().esc(x.model) + '</p>' +
        '<div class="vb-st__ro-nums"><div><b>' + V().kwh(s.kwh) + '</b><span>' + V().esc(s.parts) + '</span></div>' +
        '<div><b>' + V().watt(wNow) + '</b><span>maximaal vermogen' + (s.n > 1 ? ' samen' : '') + ', plug-in</span></div></div>' +
        '<p class="vb-st__advice">(Wij adviseren wel om de batterij altijd op een eigen, vrije groep aan te sluiten, voor zo veilig mogelijk gebruik. <a class="vb-link" href="/pages/waarom-plug-and-play">Waarom?</a>)</p>';
      if (s.onRequest) {
        out += '<p class="vb-st__price">Prijs op aanvraag. <span class="vb-small">Deze opstelling stellen we voor je samen.</span></p>';
        if (mode !== 'config') out += '<div class="vb-btns"><button type="button" class="vb-btn vb-btn--ink" data-st-maatwerk>Ik wil maatwerkadvies</button></div>';
      } else {
        out += '<p class="vb-st__price"><b>' + V().eur(s.price) + '</b>' + (s.qty > 1 ? ' <span class="vb-small">' + s.qty + ' × ' + V().eur(s.variant.price) + '</span>' : '') + '</p>';
        if (mode === 'config' && s.adviesprijs) out += '<p class="vb-st__advies">Adviesprijs ' + V().eur(s.adviesprijs) + '</p>';
        if (mode !== 'config') out += '<div class="vb-btns"><a class="vb-btn vb-btn--ink" href="' + x.url + '?variant=' + s.variant.id + (s.qty > 1 ? '&torens=' + s.qty : '') + '">Bekijk deze opstelling</a></div>';
      }
      return out;
    }

    function optsHtml(kind) {
      var x = bat(state.key), Lx = limits(x), c = cfg(x.key), rows = [];
      if (kind === 'n') {
        for (var n = 1; n <= Lx.maxN; n++) {
          var cm = clampStand(x, n, state.m), s = stand(x, cm.n, cm.m);
          var lab = n === 1 ? '1 ' + c.unit : n + ' ' + c.unitPlural;
          if (n > Lx.towersMax && c.basisWord) lab = n + ' units';
          rows.push(btn('n', n, n === state.n, lab, s, cm));
        }
      } else {
        if (state.n > Lx.towersMax) return '';
        for (var m = Lx.minM; m <= Lx.maxM; m++) { var s2 = stand(x, state.n, m); rows.push(btn('m', m, m === state.m, V().kwh(s2.kwh / state.n), s2, { n: state.n, m: m }, state.n > 1 ? 'per ' + c.unit : '')); }
      }
      return rows.join('');
    }
    function btn(kind, val, on, lab, s, cm, sub) {
      return '<button type="button" class="vb-st__opt" data-st-opt="' + kind + '" data-val="' + val + '" aria-pressed="' + on + '">' +
        '<span class="vb-st__optimg" data-mini="' + cm.n + ',' + cm.m + '" aria-hidden="true"></span>' +
        '<span class="vb-st__optlab">' + V().esc(lab) + (sub ? '<small>' + V().esc(sub) + '</small>' : '') + '</span>' +
        '<span class="vb-st__optprice">' + (s.onRequest ? 'op aanvraag' : V().eur(s.price)) + '</span></button>';
    }
    function paintMinis(box) {
      Array.prototype.forEach.call(box.querySelectorAll('[data-mini]'), function (sp) {
        var nm = sp.getAttribute('data-mini').split(','); mini(sp, state.key, +nm[0], +nm[1]);
      });
    }

    var lastAnnounce = '';
    function paint(instant) {
      var x = bat(state.key), Lx = limits(x), c = cfg(x.key), s = stand(x, state.n, state.m);
      Array.prototype.forEach.call(el.querySelectorAll('[data-st-brand]'), function (bb) { bb.setAttribute('aria-checked', String(bb.getAttribute('data-st-brand') === state.key)); });
      scene.render(state.key, state.n, state.m, instant);
      var nseg = el.querySelector('[data-st-nseg]');
      if (nseg) {
        var h = '';
        for (var n = 1; n <= Lx.maxN; n++) { var lab = n === 1 ? '1 ' + c.unit : n + ' ' + (n > Lx.towersMax && c.basisWord ? 'units' : c.unitPlural); h += '<button type="button" data-st-n="' + n + '" aria-pressed="' + (n === state.n) + '">' + lab + '</button>'; }
        nseg.innerHTML = h; nseg.hidden = Lx.maxN < 2;
        var pmv = el.querySelector('[data-st-pmval]');
        if (pmv) pmv.textContent = V().kwh(s.kwh / state.n) + (state.n > 1 ? ' per ' + c.unit : '');
        var mi = el.querySelector('[data-st-minus]'), pl = el.querySelector('[data-st-plus]');
        var fixedM = state.n > Lx.towersMax || Lx.maxM === Lx.minM;
        if (mi) mi.disabled = fixedM || state.m <= Lx.minM;
        if (pl) pl.disabled = fixedM || state.m >= Lx.maxM;
        el.querySelector('.vb-st__plusmin').hidden = Lx.maxM === Lx.minM;
      }
      var no = el.querySelector('[data-st-nopts]'), mo = el.querySelector('[data-st-mopts]');
      if (no) { no.innerHTML = optsHtml('n'); paintMinis(no); el.querySelector('[data-st-nlabel]').textContent = 'Aantal ' + c.unitPlural; no.parentNode.querySelector('[data-st-nlabel]').hidden = Lx.maxN < 2; no.hidden = Lx.maxN < 2; }
      if (mo) { var mh = optsHtml('m'); mo.innerHTML = mh; paintMinis(mo); var ml = el.querySelector('[data-st-mlabel]'); ml.textContent = state.n > 1 ? 'Capaciteit per ' + c.unit : 'Capaciteit'; ml.hidden = mo.hidden = !mh || Lx.maxM === Lx.minM; }
      el.querySelector('[data-st-readout]').innerHTML = readout(s);
      var live = x.brand + ' ' + x.model + ', ' + s.parts + ', ' + V().kwh(s.kwh) + ', maximaal ' + V().watt(s.groepW || s.stopW) + ', ' + (s.onRequest ? 'prijs op aanvraag' : V().eur(s.price));
      if (live !== lastAnnounce) { el.querySelector('[data-st-live]').textContent = live; lastAnnounce = live; }
      if (opts.form) bindForm(s);
      if (typeof opts.onChange === 'function') opts.onChange(state, s);
    }

    /* Configurator: de bestaande (verborgen) variantkeuze en het aantal meenemen, zodat winkelmand, totaal, sticky balk en installatie-optie blijven werken */
    function bindForm(s) {
      var f = opts.form, sub = f.querySelector('button[type="submit"]'), q = f.querySelector('input[name="quantity"]');
      var mwb = f.querySelector('[data-st-formmaatwerk]');
      f.setAttribute('data-stapel-label', bat(state.key).model + ' ' + s.title);
      if (s.onRequest) {
        if (sub) { sub.hidden = true; }
        if (mwb) mwb.hidden = false;
        f.setAttribute('data-op-aanvraag', 'true');
        return;
      }
      f.removeAttribute('data-op-aanvraag');
      if (sub) sub.hidden = false;
      if (mwb) mwb.hidden = true;
      if (q) q.value = String(s.qty);
      var r = f.querySelector('input[name="id"][value="' + s.variant.id + '"]');
      if (r && !r.checked) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
      else if (r) { f.dispatchEvent(new Event('change', { bubbles: true })); }
    }

    function used() {
      try { if (sessionStorage.getItem('sr_stapel_used')) return; sessionStorage.setItem('sr_stapel_used', '1'); } catch (e) {}
      V().track('stapel_gebruikt', { merk: state.key });
    }
    function ctx() {
      var x = bat(state.key), s = stand(x, state.n, state.m);
      var b = { key: x.key, naam: x.klasse, model: x.model, opstelling: s.kwh ? V().kwh(s.kwh) + ', ' + s.parts : s.parts, prijs: s.onRequest ? 'op aanvraag' : V().eur(s.price) };
      return { bron: mode === 'config' ? 'productpagina' : 'stapel', beste: b, prijsklasse: s.onRequest ? 'boven 3500' : V().prijsklasseVan(s.price),
               waText: 'Hoi SmartReserve! Ik wil graag maatwerkadvies over de ' + x.model + ': ' + b.opstelling + '.' };
    }

    el.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target : null; if (!t) return;
      var bb = t.closest('[data-st-brand]');
      if (bb) { state.key = bb.getAttribute('data-st-brand'); var x = bat(state.key), Lx = limits(x); var cm = clampStand(x, 1, mode === 'hero' ? startM(x) : Lx.minM); state.n = cm.n; state.m = cm.m; paint(false); return; }
      var nb = t.closest('[data-st-n]');
      if (nb) { used(); var c2 = clampStand(bat(state.key), +nb.getAttribute('data-st-n'), state.m); state.n = c2.n; state.m = c2.m; paint(false); return; }
      var ob = t.closest('[data-st-opt]');
      if (ob) { used(); var k = ob.getAttribute('data-st-opt'), v = +ob.getAttribute('data-val'); var c3 = clampStand(bat(state.key), k === 'n' ? v : state.n, k === 'm' ? v : state.m); state.n = c3.n; state.m = c3.m; paint(false); return; }
      if (t.closest('[data-st-minus]')) { used(); state.m = clampStand(bat(state.key), state.n, state.m - 1).m; paint(false); return; }
      if (t.closest('[data-st-plus]')) { used(); state.m = clampStand(bat(state.key), state.n, state.m + 1).m; paint(false); return; }
      if (t.closest('[data-st-maatwerk]')) { V().maatwerk.open(ctx()); }
    });
    if (opts.form) {
      var mwb = opts.form.querySelector('[data-st-formmaatwerk]');
      if (mwb) mwb.addEventListener('click', function (e) { e.preventDefault(); V().maatwerk.open(ctx()); });
    }

    var ro = 'ResizeObserver' in root ? new ResizeObserver(function () { scene.camera(true); }) : null;
    if (ro) ro.observe(stage); else root.addEventListener('resize', function () { scene.camera(true); });

    // Eerste beeld: in de hero bouwt de toren zich op (zonder beweging direct de eindstand)
    if (mode === 'hero' && !reduced && !opts.noIntro) {
      var target = state.m; state.m = Math.min(target, limits(bat(state.key)).minM);
      paint(true);
      var timer = setInterval(function () { if (state.m >= target) { clearInterval(timer); return; } state.m++; paint(false); }, 520);
      el.addEventListener('pointerdown', function () { clearInterval(timer); }, { once: true });
    } else { paint(true); }

    return {
      start: function (key) { if (key && bat(key)) state.key = key; var b0 = bat(state.key), c0 = clampStand(b0, 1, startM(b0)); state.n = c0.n; state.m = c0.m; paint(false); },
      set: function (key, n, m) { if (key && bat(key)) state.key = key; var cs2 = clampStand(bat(state.key), n || state.n, m || state.m); state.n = cs2.n; state.m = cs2.m; paint(false); },
      state: function () { return { key: state.key, n: state.n, m: state.m, aansl: state.aansl }; }
    };
  }

  root.SRStapel = { mount: mount, mini: mini, stand: stand, limits: limits };
})(window);
